export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Military-Grade Encryption',
      description: 'Your data is protected with AES-256 encryption, the same standard used by governments and security experts worldwide to ensure maximum privacy and security.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Lightning Fast Speeds',
      description: 'Enjoy seamless browsing, streaming, and downloading with our optimized servers. Experience minimal speed loss while maintaining complete security and privacy.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Connect to servers in multiple countries worldwide. Access geo-restricted content and enjoy a truly borderless internet experience with low latency connections.'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'No-Logs Policy',
      description: 'We never track, collect, or share your private data. Your online activities remain completely anonymous and private, ensuring your digital footprint stays yours alone.'
    },
    {
      icon: 'ri-device-line',
      title: 'Multi-Device Support',
      description: 'Protect all your devices with a single account. Compatible with Windows, Mac, iOS, Android, and Linux. Secure your entire digital ecosystem effortlessly.'
    },
    {
      icon: 'ri-customer-service-line',
      title: '24/7 Customer Support',
      description: 'Our dedicated support team is always ready to assist you. Get help whenever you need it through email, chat, or phone support for a seamless experience.'
    }
  ];

  return (
    <section id="features" className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose VOS VPN?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover the powerful features that make VOS VPN the perfect choice for protecting your online privacy and security
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-indigo-100 rounded-xl mb-6">
                <i className={`${feature.icon} text-3xl text-indigo-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
